module.exports = __webpack_public_path__ + "img/timeline.7e0fc769.png";